import React from 'react';

import './Architecture.css';
import './Architecture.mobile.css';


const Architecture = () => {

    const architectureSpecifications = [
        {
            id: '01',
            category: 'STRUCTURE',
            title: 'Conception Modulaire',
            description:
                'Systèmes isolés pour une maintenance sans friction et une scalabilité horizontale infinie.'
        },
        {
            id: '02',
            category: 'LOGIQUE',
            title: 'Séparation des Flux',
            description:
                'Déconnexion stricte Front/Back garantissant flexibilité et interopérabilité totale.'
        },
        {
            id: '03',
            category: 'ÉCHANGE',
            title: 'Normalisation API',
            description:
                'Protocoles REST & JSON pour une intégration native des écosystèmes IA (OpenAI, Claude).'
        },
        {
            id: '04',
            category: 'DONNÉES',
            title: 'Ingénierie Data',
            description:
                'Persistance hybride SQL/Vectorielle optimisée par des couches de cache haute performance.'
        }
    ];


    return (

        <section
            className="architecture-section"
            aria-labelledby="architecture-title"
        >

            <div className="architecture-container">


                {/* =================================================
                    HERO
                    ================================================= */}

                <header className="architecture-hero">

                    <h1
                        id="architecture-title"
                        className="architecture-title"
                    >
                        ARCHITECTURE
                    </h1>


                    <div className="architecture-hero-intro">

                        <span className="architecture-hero-intro-label">
                            PRINCIPE
                        </span>


                        <p className="architecture-hero-intro-text">

                            Bâtir des infrastructures

                            <strong>
                                {" "}robustes, modulaires et évolutives{" "}
                            </strong>

                            capables d'accompagner les besoins de demain.

                        </p>

                    </div>

                </header>


                {/* =================================================
                    DESKTOP
                    ================================================= */}

                <div className="architecture-desktop-layout">


                    <div className="architecture-desktop-grid">

                        {architectureSpecifications.map(
                            (specification) => (

                                <article
                                    key={specification.id}
                                    className="architecture-card"
                                >

                                    <header className="architecture-card-header">

                                        <span className="architecture-card-number">
                                            {specification.id}
                                        </span>


                                        <span className="architecture-card-category">
                                            {specification.category}
                                        </span>

                                    </header>


                                    <div className="architecture-card-content">

                                        <h2 className="architecture-card-title">
                                            {specification.title}
                                        </h2>


                                        <div className="architecture-card-rule" />


                                        <p className="architecture-card-description">
                                            {specification.description}
                                        </p>

                                    </div>


                                    <footer className="architecture-card-footer">

                                        <span>
                                            ARCH / {specification.id}
                                        </span>


                                        <span>
                                            {specification.category}
                                        </span>

                                    </footer>

                                </article>

                            )
                        )}

                    </div>


                    {/* =================================================
                        CORE DESKTOP
                        ================================================= */}

                    <aside className="architecture-core">

                        <div className="architecture-core-main">

                            <span className="architecture-core-kicker">
                                CRITICAL CORE
                            </span>


                            <h2 className="architecture-core-title">
                                Écosystème
                                <br />
                                d'automatisation
                            </h2>


                            <div className="architecture-core-rule" />


                            <p className="architecture-core-description">
                                Intégration native de pipelines IA multi-agents
                                et conteneurisation Docker pour une stabilité
                                d'exécution absolue.
                            </p>


                            <div className="architecture-core-tags">

                                <span>
                                    CREWAI
                                </span>

                                <span>
                                    LANGCHAIN
                                </span>

                                <span>
                                    DOCKER
                                </span>

                            </div>

                        </div>


                        <footer className="architecture-core-footer">

                            <span className="architecture-core-footer-label">
                                INFRASTRUCTURE
                            </span>


                            <p>
                                Automatiser sans sacrifier
                                la stabilité du système.
                            </p>

                        </footer>

                    </aside>

                </div>


                {/* =================================================
                    MOBILE
                    ================================================= */}

                <div
                    className="architecture-mobile-track"
                    role="region"
                    aria-label="Architecture et infrastructure"
                >


                    {/* =================================================
                        SLIDE 01
                        ================================================= */}

                    <article className="architecture-mobile-panel architecture-mobile-panel-list">

                        <header className="architecture-mobile-panel-header">

                            <span className="architecture-mobile-panel-index">
                                01
                            </span>


                            <span className="architecture-mobile-panel-badge">
                                ARCHITECTURE
                            </span>

                        </header>


                        <div className="architecture-mobile-list">

                            {architectureSpecifications.map(
                                (specification) => (

                                    <div
                                        key={`mobile-list-${specification.id}`}
                                        className="architecture-mobile-list-item"
                                    >

                                        <div className="architecture-mobile-list-content">

                                            <h2 className="architecture-mobile-list-title">
                                                {specification.title}
                                            </h2>


                                            <p className="architecture-mobile-list-description">
                                                {specification.description}
                                            </p>

                                        </div>

                                    </div>

                                )
                            )}

                        </div>

                    </article>


                    {/* =================================================
                        SLIDE 02 — CORE
                        ================================================= */}

                    <article className="architecture-mobile-panel architecture-mobile-panel-core">

                        <header className="architecture-mobile-panel-header">

                            <span className="architecture-mobile-panel-index">
                                02
                            </span>


                            <span className="architecture-mobile-panel-badge">
                                IA
                            </span>

                        </header>


                        <div className="architecture-mobile-core-content">

                            <span className="architecture-mobile-core-kicker">
                                CRITICAL CORE
                            </span>


                            <h2 className="architecture-mobile-core-title">
                                Écosystème d'automatisation
                            </h2>


                            <div className="architecture-mobile-core-rule" />


                            <p className="architecture-mobile-core-description">
                                Intégration native de pipelines IA multi-agents
                                et conteneurisation Docker pour une stabilité
                                d'exécution absolue.
                            </p>


                            <div className="architecture-mobile-core-tags">

                                <span>
                                    CREWAI
                                </span>

                                <span>
                                    LANGCHAIN
                                </span>

                                <span>
                                    DOCKER
                                </span>

                            </div>

                        </div>

                    </article>

                </div>


                {/* =================================================
                    FINAL
                    ================================================= */}

                <footer className="architecture-final">

                    <span className="architecture-final-label">
                        CONSTRUIRE POUR DURER
                    </span>


                    <p className="architecture-final-text architecture-final-text-desktop">
                        L'architecture déployée aujourd'hui est conçue
                        pour vos besoins de demain.
                    </p>


                    <p className="architecture-final-text architecture-final-text-mobile">
                        Stable aujourd'hui.
                        <br />
                        Extensible demain.
                    </p>

                </footer>


            </div>

        </section>

    );
};


export default Architecture;